// Component Imports
import { defineAsyncComponent } from "vue";

// Main Layout
const AdminPanel = defineAsyncComponent(() =>
    import("@/components/AdminPanel.vue")
);

// Page Components
const ADMIN_COMPONENTS = {
    DashBoard: defineAsyncComponent(() =>
        import("../components/pages/admin/AdminDashBoard.vue")
    ),
    RegisterTruck: defineAsyncComponent(() =>
        import("../components/pages/admin/RegisterTruck.vue")
    ),
    RegisteredTrucks: defineAsyncComponent(() =>
        import("../components/pages/admin/RegisteredTrucks.vue")
    ),
    RegisteredUsers: defineAsyncComponent(() =>
        import("../components/pages/admin/RegisteredUsers.vue")
    ),
    RegisteredDrivers: defineAsyncComponent(() =>
        import("../components/pages/admin/RegisteredDrivers.vue")
    ),
    RequestsPage: defineAsyncComponent(() =>
        import("../components/pages/admin/RequestsPage.vue")
    ),
    BillsPage: defineAsyncComponent(() =>
        import("../components/pages/admin/BillsPage.vue")
    ),
    UpdateTruckData: defineAsyncComponent(() =>
        import("../components/pages/admin/UpdateTruckData.vue")
    ),
    UpdateUserData: defineAsyncComponent(() =>
        import("../components/pages/admin/UpdateUserData.vue")
    ),
    RequestAnswer: defineAsyncComponent(() =>
        import("../components/pages/admin/RequestAnswer.vue")
    ),
    SettingPage: defineAsyncComponent(() =>
        import("../components/pages/admin/SettingPage.vue")
    ),
    AdjustmentsPage: defineAsyncComponent(() =>
        import("../components/pages/admin/AdjustmentsPage.vue")
    ),
    UploadBillPage: defineAsyncComponent(() =>
        import("../components/pages/admin/UploadBillPage.vue")
    ),
    UploadAdjustmentPage: defineAsyncComponent(() =>
        import("../components/pages/admin/UploadAdjustmentPage.vue")
    ),
    AdminSetting: defineAsyncComponent(() =>
        import("../components/pages/admin/AdminSetting.vue")
    ),
    UpdateAdminData: defineAsyncComponent(() =>
        import("../components/pages/admin/UpdateAdminData.vue")
    ),
    NoticePage: defineAsyncComponent(() =>
        import("../components/pages/admin/NoticePage.vue")
    ),
    CreateNotice: defineAsyncComponent(() =>
        import("../components/pages/admin/CreateNotice.vue")
    ),
    EditNotice: defineAsyncComponent(() =>
        import("../components/pages/admin/EditNotice.vue")
    ),
    ExcelImport: defineAsyncComponent(() =>
        import("../components/pages/admin/ExcelImport.vue")
    ),
    ShippingBills: defineAsyncComponent(() =>
        import("../components/pages/admin/ShippingBill.vue")
    ),
    RegisterBills: defineAsyncComponent(() =>
        import("../components/pages/admin/RegisterShippedBills.vue")
    ),
    ReportPdf: defineAsyncComponent(() =>
        import("../components/pages/admin/HtmlToPDF.vue")
    ),
    BackupData: defineAsyncComponent(() =>
        import("../components/pages/admin/AdminBackups.vue")
    ),
    TutorialSection: defineAsyncComponent(() =>
        import("../components/pages/admin/sections/TutorialSection.vue")
    ),
    ShowLogs: defineAsyncComponent(() =>
        import("../components/pages/admin/ShowLogs.vue")
    ),
};

// Route Configurations
const ADMIN_ROUTES = {
    BASE: {
        path: "/admin",
        name: "adminpanel",
        component: AdminPanel,
        redirect: { name: "dashboard" },
        meta: { requiresAuthLevelTwo: true, title: "پنل مدیریت" },
    },
    ROUTES: [
        {
            path: "dashboard",
            name: "dashboard",
            component: ADMIN_COMPONENTS.DashBoard,
        },
        {
            path: "registertruck",
            name: "registertruck",
            component: ADMIN_COMPONENTS.RegisterTruck,
        },
        {
            path: "trucks",
            name: "registeredtrucks",
            component: ADMIN_COMPONENTS.RegisteredTrucks,
        },
        {
            path: "users",
            name: "registeredusers",
            component: ADMIN_COMPONENTS.RegisteredUsers,
        },
        {
            path: "drivers",
            name: "registeredDrivers",
            component: ADMIN_COMPONENTS.RegisteredDrivers,
        },
        {
            path: "bills",
            name: "billspage",
            component: ADMIN_COMPONENTS.BillsPage,
        },
        {
            path: "requests",
            name: "requestspage",
            component: ADMIN_COMPONENTS.RequestsPage,
        },
        {
            path: "truck/:id",
            name: "edittruckdata",
            component: ADMIN_COMPONENTS.UpdateTruckData,
        },
        {
            path: "users/:id",
            name: "editUserData",
            component: ADMIN_COMPONENTS.UpdateUserData,
        },
        {
            path: "requests/:id",
            name: "requestAnswer",
            component: ADMIN_COMPONENTS.RequestAnswer,
        },
        {
            path: "setting",
            name: "settingPage",
            component: ADMIN_COMPONENTS.SettingPage,
        },
        {
            path: "uploadbill",
            name: "uploadBill",
            component: ADMIN_COMPONENTS.UploadBillPage,
        },
        {
            path: "adminsetting",
            name: "adminSetting",
            component: ADMIN_COMPONENTS.AdminSetting,
        },
        {
            path: "adminsetting/:id",
            name: "updateAdminData",
            component: ADMIN_COMPONENTS.UpdateAdminData,
        },
        {
            path: "uploadAdjustment",
            name: "uploadAdjustmentPage",
            component: ADMIN_COMPONENTS.UploadAdjustmentPage,
        },
        {
            path: "adjustments",
            name: "adjustments-page",
            component: ADMIN_COMPONENTS.AdjustmentsPage,
        },
        {
            path: "notice",
            name: "NoticePage",
            component: ADMIN_COMPONENTS.NoticePage,
        },
        {
            path: "create-notice",
            name: "createNotice",
            component: ADMIN_COMPONENTS.CreateNotice,
        },
        {
            path: "notice/:id",
            name: "editNotice",
            component: ADMIN_COMPONENTS.EditNotice,
        },
        {
            path: "import-user",
            name: "excelImport",
            component: ADMIN_COMPONENTS.ExcelImport,
        },
        {
            path: "shipping-bills",
            name: "shippingBills",
            component: ADMIN_COMPONENTS.ShippingBills,
        },
        {
            path: "register-bills",
            name: "registerShippedBills",
            component: ADMIN_COMPONENTS.RegisterBills,
        },
        {
            path: "report-pdf",
            name: "reportPdf",
            component: ADMIN_COMPONENTS.ReportPdf,
        },
        {
            path: "backup-data",
            name: "backupDataBase",
            component: ADMIN_COMPONENTS.BackupData,
        },
        {
            path: "tutorials",
            name: "tutorialsSection",
            component: ADMIN_COMPONENTS.TutorialSection,
        },
        {
            path: "logs",
            name: "showLogs",
            component: ADMIN_COMPONENTS.ShowLogs,
        },
    ],
};

// Final Route Configuration
const adminRoutes = [
    {
        ...ADMIN_ROUTES.BASE,
        children: ADMIN_ROUTES.ROUTES,
    },
];

export default adminRoutes;
